import { useCallback, useState } from "react";
import {
  getAppToken,
  setAppSession,
  clearAppToken,
} from "../lib/app-storage";
import { appLogin } from "../lib/api";

export function useAppSession() {
  const [token, setToken] = useState<string | null>(() => getAppToken());
  const isAuthenticated = !!token;

  const login = useCallback(async (sucursalId: number, pin: string) => {
    const res = await appLogin(sucursalId, pin);
    setAppSession(res.token, res.expires_at, sucursalId);
    setToken(res.token);
  }, []);

  const logout = useCallback(() => {
    clearAppToken();
    setToken(null);
  }, []);

  return { token, isAuthenticated, login, logout };
}
